.close {
  position: absolute;
  top: 0.2rem;
  width: 1.6rem;
  height: 1.6rem;
  right: 0.2rem;
  opacity: 0.8;
  cursor: pointer;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 100ms ease-in-out;

  svg {
    width: 0.8rem;
    height: 0.8rem;
    fill: var(--text-color-white);
    stroke: var(--text-color-white);
  }

  &:hover {
    background-color: rgba(255, 255, 255, 25%);
  }
}
